import { Component } from '@angular/core';
import { soundpostReconRunEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Recon Runs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreconrun-form',
    templateUrl: './soundpostreconrun.form.component.html'
})
export class soundpostReconRunFormComponent extends BaseFormComponent {
    public record!: soundpostReconRunEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reconFlowSnapshots', sectionName: 'Recon Flow Snapshots', isExpanded: false },
            { sectionKey: 'trialBalances', sectionName: 'Trial Balances', isExpanded: false },
            { sectionKey: 'reconRunIntegrations', sectionName: 'Recon Run Integrations', isExpanded: false },
            { sectionKey: 'reconBalanceSnapshots', sectionName: 'Recon Balance Snapshots', isExpanded: false }
        ]);
    }
}

